/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { SectionGrid } from "frontend/src/components/Layout"
import { BlockText } from "frontend/src/components/BlockText"
import { CMSLink } from "frontend/src/components/CMSLink"
import { Icon } from "frontend/src/components/Icon"

function Helpcenter({ title, content, kacheln }) {
  return (
    <SectionGrid>
      <SectionGrid.narrow sx={{ pt: 8, px: ["1rem", "1rem", 0], pb: "72px" }}>
        <h2 sx={{ variant: "text.h2", pb: 2 }}>{title}</h2>
        <BlockText blocks={content} />
        <div
          sx={{
            display: "grid",
            gridTemplateColumns: ["1fr", "1fr 1fr", "1fr 1fr 1fr"],
            gridGap: ["1rem", "1rem", "2rem"],
            pt: 5,
          }}
        >
          {kacheln.map((kachel, index) => {
            const { title, link, icon } = kachel
            return (
              <div
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr",
                  border: "2px solid black",
                  alignItems: "center",
                  justifyItems: "center",
                }}
              >
                <CMSLink link={link}>
                  <div key={index} sx={{ display: "grid" }}>
                    <Icon
                      name={icon}
                      size={120}
                      color="black"
                      sx={{ justifySelf: "center", pt: 3 }}
                    />
                    <h4 sx={{ textAlign: "center", pb: 4 }}>{title}</h4>
                  </div>
                </CMSLink>
              </div>
            )
          })}
        </div>
      </SectionGrid.narrow>
    </SectionGrid>
  )
}

export { Helpcenter }
